export class PagedResponse<T> {
    items!: T[];
    page!: number;
    pageSize!: number;
    totalCount!: number;
}
